import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { environment } from '@environments/environment';
import { DataService } from '@app/_services/data.service';
import { Employee } from '@app/_models/_DTOs/employee';
import { ITuple } from '@app/_models/tuple';
import { Asset } from '@app/_models/_DTOs/asset';
import { Document } from '@app/_models/_DTOs/document';
import { AssetHistoryActionType } from '@app/_models/assetHistoryActionType';
import { AssetService } from '@app/_services';
import { AssetUnassignmentViewModel } from '@app/_models/_viewModels/assetUnassignment.viewmodel';

@Injectable({ providedIn: 'root' })
export class DocumentService extends DataService<Document> {
    constructor(http: HttpClient, private assetService: AssetService) {
        super(http, "api/documents")
    }

    generateDocument(assets: Asset[]) {
        var assetIds = assets.map(x => x.id);
        // assets.forEach(asset => {
        //     asset.assetHistory.forEach(action => {
        //         var logTime = new Date(action.logTime);
        //         if (action.actionType == AssetHistoryActionType.AssignToEmployee) {
        //             var mostRecentDate = this.assetService.getMostRecentDateOfAction(asset.assetHistory, action.actionType);
        //             if (mostRecentDate) {
        //                 if (logTime.getTime() == mostRecentDate.getTime()) {
        //                     if (asset.employee) {
        //                         // gledamo samo akcije koje još uvijek vrijede
        //                         if (asset.employee.id == action.newEmployee.id) {
        //                             assetHistoryIds.push(action.id);
        //                         }
        //                     }
        //                 }
        //             }
        //         }
        //         else if (action.actionType == AssetHistoryActionType.AssignToLocation) {
        //             var mostRecentDate = this.assetService.getMostRecentDateOfAction(asset.assetHistory, action.actionType);
        //             if (mostRecentDate) {
        //                 if (logTime.getTime() == mostRecentDate.getTime()) {
        //                     if (asset.location) {
        //                         // gledamo samo akcije koje još uvijek vrijede
        //                         if (asset.location.id == action.newLocation.id) {
        //                             if (asset.location.personInCharge) {
        //                                 assetHistoryIds.push(action.id);
        //                             }
        //                         }
        //                     }
        //                 }
        //             }
        //         }
        //     });
        // });
        return this.saveDocument(assetIds);
    }

    saveDocument(assetIds: number[]) {

        return this.http.post(`${environment.apiUrl}/${this.endpoint}/GenerateAssignmentDocument`,
            { AssetIds: assetIds }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            responseType: "blob"
        });
    }

    saveUnassignmentDocument(assetUnassignmentViewModel: AssetUnassignmentViewModel) {

        return this.http.post(`${environment.apiUrl}/${this.endpoint}/GenerateUnassignmentDocument`,
            assetUnassignmentViewModel, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            responseType: "blob"
        });
    }

    getPdf(documentId: number) {
        return this.http.get(`${environment.apiUrl}/${this.endpoint}/GetPdf/${documentId}`, { responseType: "blob" });
    }
}